import { Database } from "lucide-react"
import type { NotificationRenderer } from "../../types"
import { navigateForAction } from "../actionRoutes"

// Icon mirrors the sidebar's knowledgebase entry (AppSidebarV2 ICONS.database).
// Payload is untrusted: type-guard before using a field as a param.
export const documentIngestionFailed: NotificationRenderer = {
  icon: Database,
  accent: "error",
  title: (payload) =>
    typeof payload?.filename === "string"
      ? { key: "NOTIF/DOC_FAILED/TITLE", params: { filename: payload.filename } }
      : { key: "NOTIF/DOC_FAILED/TITLE_GENERIC" },
  description: () => ({ key: "NOTIF/DOC_FAILED/DESC" }),
  cta: "NOTIF/CTA/OPEN_KNOWLEDGEBASE",
  onAction: navigateForAction,
}
